/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { put, select, take } from 'redux-saga/effects';

import {
  FETCH_DESTINATION_BRANCH,
  LOAD_PULL_REQUEST,
} from 'src/redux/pull-request/actions';
import { getDestinationBranchName } from 'src/redux/pull-request/selectors';
import fetchRepositoryBranch from 'src/sections/repository/actions/fetch-repository-branch';

export function* fetchDestinationBranch(owner: string, slug: string) {
  let destinationBranchName: string = yield select(getDestinationBranchName);

  if (!destinationBranchName) {
    yield take(LOAD_PULL_REQUEST.SUCCESS);

    destinationBranchName = yield select(getDestinationBranchName);
  }

  yield put(
    fetchRepositoryBranch(
      FETCH_DESTINATION_BRANCH,
      `${owner}/${slug}`,
      destinationBranchName
    )
  );
}
